/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import axios from '@/plugins/axios';

const defaults = {
  token: localStorage.getItem('token') || null,
  expire: localStorage.getItem('expire') || null,
  login: {
    name: localStorage.getItem('login.name') || null,
    id: localStorage.getItem('login.id') || null,
    publisher: localStorage.getItem('publisher') || null,
  },
};

const auth = {
  namespaced: true,

  state: Object.assign({}, defaults),

  mutations: {
    update(state, data) {
      state = Object.assign({}, defaults, data);
    },
    updateToken(state, data) {
      state.token = data.access_token;
      state.expire = Date.now() + (data.expires_in * 1000);
      axios.defaults.headers.common.Authorization = `Bearer ${state.token}`;
      localStorage.setItem('token', state.token);
      localStorage.setItem('expire', state.expire);
    },
    updateLogin(state, loginData) {
      state.login = Object.assign({}, state.login, {
        name: loginData.name,
        publisher: loginData.publisher_id,
      });
      localStorage.setItem('login.name', state.login.name);
      localStorage.setItem('login.id', state.login.id);
      localStorage.setItem('login.publisher', state.login.publisher);
    },
    clear(state) {
      state = Object.assign(state, {
        token: null,
        expire: null,
        login: {
          name: null,
          id: null,
          publisher: null,
        },
      });
    },
  },

  actions: {
    clear({
      state,
      commit,
      rootState,
      dispatch,
    }) {
      commit('clear');
    },
    login({ commit }, data) {
      commit('updateToken', data);
    },
    update({ state, commit, rootState }, data) {
      commit('update', data);
    },
  },
};

export default auth;
